import { freezeNav, unfreezeNav } from "./layout/_header";

if (document.querySelector("#btnClose")) {
  document.querySelectorAll("#btnClose").forEach(el => { el.addEventListener(
    "click",
    async (event) => {
        event.preventDefault();
        let secondlevel = document.querySelectorAll(".mobileNav__slideMenu.mobileNav__slideMenu--level2.isCovered");
        let sideBar = document.querySelector("#NavMovil");
        let optionsToLevelTwo = document.querySelectorAll(".mobileNav__link-2.collapse.show")
        document.getElementById('btnClose').classList.toggle("d-none");
            document.getElementById('btnOpen').classList.toggle("d-none");
        sideBar.classList.remove("effectDown");
        sideBar.classList.add("effectUp");
        unfreezeNav();
      if(secondlevel.length > 0){
        secondlevel.forEach(el=> closesecondlevel(el));
      }
      if(optionsToLevelTwo.length > 0){
        optionsToLevelTwo.forEach(element => {
           element.classList.remove("show");
        });
      }
      setTimeout(() => {
        sideBar.style.display = "none";
      }, 505);
    },
    false
  );
 });
}


if (document.querySelector("#btnOpen")) {
    document.querySelector("#btnOpen").addEventListener(
        "click",
        (event) => {
        event.preventDefault();
        let sideBar = document.querySelector("#NavMovil");
        sideBar.style.display = "block";
        document.getElementById('btnClose').classList.toggle("d-none");
        document.getElementById('btnOpen').classList.toggle("d-none");
        freezeNav();
        sideBar.classList.remove("effectUp");
        sideBar.classList.add("effectDown");
        },
        false
    );
}

function closesecondlevel(menu) {
    menu.style.transform = "translate(100%, 0%)";
}

class MobileNav {
    constructor (element, options) {
      if (!element) {
        return
      }
  
      this.element = element
      this.topLevelListItem = options.topLevelListItem
      this.topLevelLink = options.topLevelLink
      this.dropdown = options.dropdown
      this.goBackBtn = options.goBackBtn
      this.slideMenu = options.slideMenu
    }
  
    init () {
      if (!this.element) {
        return
      }
      this.attachEvents()
    }
  
    attachEvents () {
  
      let self = this
      let currentTab;
  
      document.querySelectorAll(this.goBackBtn).forEach(el =>{
          el.addEventListener("click", e=>{
              e.currentTarget.parentNode.parentNode.parentNode.style.transform = "translate(100%, 0%)";
              currentTab = e.currentTarget.parentNode.parentNode.parentNode.parentNode.querySelector('section');
              currentTab.classList.remove('isCovered');
          });
      });
  
      document.querySelectorAll(this.topLevelLink).forEach(el=>{
          el.addEventListener("click", e=>{
              console.log(e);
              let dropdown = e.currentTarget.parentNode.querySelector(self.slideMenu).querySelector(self.dropdown);
              let slideMenu = e.currentTarget.parentNode.querySelector(self.slideMenu);
              currentTab = e.currentTarget.parentNode.querySelector('section');
              if (dropdown.childNodes.length) {
                slideMenu.style.transform = "translate(0%, 0%)";
                currentTab.classList.add('isCovered');
                return false
              }
          });
      });
    }
  }
  
  
  
  window.addEventListener('load', (event) =>{
      const mobileNav = new MobileNav('.mobileNav', {
          goBackBtn: '.mobileNav__goBackBtnContainer',
          slideMenu: '.mobileNav__slideMenu',
          topLevelListItem: '.mobileNav__listItem',
          topLevelLink: '.mobileNav__link',
          dropdown: '.mobileNav__dropdown'
      })
        
      mobileNav.init()
  });
